import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiRequest } from '../../lib/api';
import { useAuthStore } from '../../store/authStore';
import './VerifyEmailPage.css';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const fetchMe = useAuthStore((state) => state.fetchMe);
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>(token ? 'verifying' : 'error');

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    const verify = async () => {
      try {
        await apiRequest('/user/verify-email', { method: 'POST', json: { token } });
        if (cancelled) return;
        setStatus('success');
        // Refresh the session user so the profile badge shows Verified.
        fetchMe();
      } catch {
        if (!cancelled) setStatus('error');
      }
    };
    verify();
    return () => {
      cancelled = true;
    };
  }, [token, fetchMe]);

  return (
    <section className="verify-email">
      {status === 'verifying' && <p className="verify-email__status">Verifying your email…</p>}
      {status === 'success' && (
        <>
          <h1 className="verify-email__title">Email verified!</h1>
          <p className="verify-email__status">Thank you — your email address is now verified.</p>
          <Link className="verify-email__link" to="/">
            Continue shopping
          </Link>
        </>
      )}
      {status === 'error' && (
        <>
          <h1 className="verify-email__title">Verification failed</h1>
          <p className="verify-email__status">
            This verification link is invalid or has expired. Please contact us to request a new one.
          </p>
          <Link className="verify-email__link" to="/">
            Back to home
          </Link>
        </>
      )}
    </section>
  );
}
